import React, { Suspense } from 'react'
import { withRouter, BrowserRouter } from 'react-router-dom'
import queryString from 'query-string'
import { connect } from 'react-redux'

import '../../App.css'
import LoadingScreen from 'components/reusable/legacy/other/loading_screen.js'
import AuthHelper from 'helpers/auth_helper'
import ApplicationHelper from 'helpers/application_helper'
import WebNotificationHelper from 'helpers/web_notification_helpers'
import FaviconHighlighter from '../reusable/legacy/other/favicon_highlighter'
import ModalsView from 'components/views/modals_view'
import { ModalContext, RootContext } from 'contexts/contexts'
import Modal, { modalEnum } from 'components/modals/v2/modal'
import Footer from 'components/complex/footer/footer'
import { searchParams } from 'helpers/router_helper'
import SCTrack from 'classes/sc_track'
import { Wrapper } from './styled'
import Router from './router'
import UaBanner from 'components/static/ua_banner'
import Header from 'components/reusable/header/header'
import withUaBannerProvider from 'hocs/with_ua_banner_provider'
import InitHelper from 'helpers/init_helper'
import UserHelpers from 'helpers/user_helpers'
import LoadingComponent from 'components/reusable/loading/LoadingComponent'
import MobileNavigation from 'components/complex/mobile_navigation'
import { LocalStorage } from 'classes/sc_localstorage'

class RootWrapper extends React.Component {
  state = {
    onAuthSuccess: null,
    manualOverflow: null,
    // currentModalContent: modalEnum.requestNotificationPermissions,
    currentModalContent: null,
    modalProps: {},
    show_connect_request_recipient: false,
    show_invite_project: false,
    show_invite_friend: false,
    show_job_review: true,
    show_add_board_modal: false,
    add_board_swipecast_user_id: null,
    connect_request_recipient_swipecast_user_id: {},
    connect_request_sender_swipecast_user_id: {},
    book_user_id: null,
    invite_project_user: null,
    loading_msg: null,
    show_loading: false,
    // show_loading: true,
    showSpinner: true,
    showShareModal: false,
    boards_triggered: false,
    mode: queryString.parse(window.location.search).mode,
    messenger_active: localStorage.getItem('messenger_active')
      ? JSON.parse(localStorage.getItem('messenger_active'))
      : true,
    active_mini_chat_window_user_ids: localStorage.getItem('active_mini_chat_window_user_ids')
      ? JSON.parse(localStorage.getItem('active_mini_chat_window_user_ids'))
      : [],
  }

  async componentDidMount() {
    InitHelper.resizeInit()
    InitHelper.ajaxInit()
    InitHelper.authInit() // Eventually we have to move current user to store and call this method each time when user is set
    InitHelper.trackingInit()
    InitHelper.setSearchParamsToStorage()
    InitHelper.webPushInit(false)
    SCTrack.appCuesPage()

    const uncompleted = this.handleCompleteProfileModal()
    if (!uncompleted) this.scheduleNotificationPermissionsRequest()
  }

  scheduleNotificationPermissionsRequest = () => {
    const timeoutSeconds = process.env.NODE_ENV === 'development' ? 5 : 30
    setTimeout(() => {
      const today = new Date(),
        remindDate = LocalStorage.fetchPushPermissionsRemindAt(),
        alreadyAsked = !!LocalStorage.fetchPushPermissionsAskedAt(),
        remindDatePassed = remindDate ? today >= remindDate : false

      const canAskPermission =
        WebNotificationHelper.canAskPermission() &&
        AuthHelper.logged_in &&
        !ApplicationHelper.isMobile &&
        (!alreadyAsked || remindDatePassed) &&
        !this.state.currentModalContent

      if (canAskPermission) this.onOpenModal(modalEnum.requestNotificationPermissions)
    }, 1000 * timeoutSeconds)
  }

  setOnAuthSuccess = (onAuthSuccess) => this.setState(() => ({ onAuthSuccess }))

  handleAuthSuccess = async () => {
    if (!this.state.onAuthSuccess) return false
    const result = await this.state.onAuthSuccess()
    this.setOnAuthSuccess(null)
    return result
  }

  setMode = (mode) => this.setState(() => ({ mode }))

  toggleMessenger = () => {
    const new_messenger_active = !this.state.messenger_active
    this.setState({ messenger_active: new_messenger_active })
    localStorage.setItem('messenger_active', JSON.stringify(new_messenger_active))
  }

  hideChatWindow = (index) => {
    const storageProfiles = this.state.active_mini_chat_window_user_ids
    storageProfiles.splice(index, 1)
    this.setState({ active_mini_chat_window_user_ids: storageProfiles })
    localStorage.setItem('active_mini_chat_window_user_ids', JSON.stringify(storageProfiles))
  }

  toggleConnectRequestRecipient = (connect_request_details) => {
    this.setState({
      show_connect_request_recipient: true,
      connect_request_recipient_swipecast_user_id: connect_request_details.swipecast_user_id,
    })
  }

  toggleConnectRequestSender = (connect_request_details, onRequestSuccess = () => {}) => {
    this.setState({
      show_connect_request_sender: true,
      connect_request_sender_swipecast_user_id: connect_request_details.swipecast_user_id,
      on_connect_request_sender_success: onRequestSuccess,
    })
  }

  hideConnectRequestRecipient = () => {
    this.setState({ show_connect_request_recipient: false })
  }

  toggleAddBoardModal = (swipecast_user_id) => {
    this.setState({ show_add_board_modal: true, add_board_swipecast_user_id: swipecast_user_id })
  }

  toggleShareModal = (swipecast_user_id) => {
    this.setState({ showShareModal: true, user_id: swipecast_user_id })
  }

  toggleInviteToJobPopup = (user) => {
    this.setState({ show_invite_project: true, invite_project_user: user })
  }

  toggleMiniChat = (chat_user) => {
    const swipecast_user_id = chat_user.swipecast_user_id
    // current chat window is arbiter of truth
    const storageProfiles = this.state.active_mini_chat_window_user_ids
    storageProfiles.unshift(swipecast_user_id)
    if (storageProfiles.length > 3) {
      storageProfiles.splice(-1)
    }
    this.setState({ active_mini_chat_window_user_ids: Array.from(new Set(storageProfiles)) })
    localStorage.setItem('active_mini_chat_window_user_ids', JSON.stringify(storageProfiles))
  }

  handleCompleteProfileModal = () => {
    const verificationInfoMissing =
      UserHelpers.signupUncompleted(AuthHelper.currentUser()) && !ApplicationHelper.isMobile // there is another flow on mobile
    const profileUncompleted = AuthHelper.logged_in_profile_types?.length === 0 || verificationInfoMissing
    const q = queryString.parse(window.location.search)
    const guestOnboarding = q.mode === searchParams.modes.guestOnboarding

    if (profileUncompleted && !guestOnboarding) {
      this.onOpenModal(modalEnum.signUpAdditionalDetails)
      return true
    }

    return false
  }

  onCloseConnectRequestSender = () =>
    this.setState({ show_connect_request_sender: false, on_connect_request_sender_success: () => {} })

  embedMode = () => this.state.mode === searchParams.modes.embed
  faviconHighlighter = () => this.state.mode !== searchParams.modes.embed && !ApplicationHelper.isMobile

  onChangeManualOverflow = (manualOverflow) => this.setState(() => ({ manualOverflow }))

  componentDidUpdate = () => SCTrack.appCuesPage()
  onCloseConnectRequest = () => this.setState({ show_connect_request_recipient: false })
  onCloseShare = () => this.setState({ showShareModal: false })
  onCloseInviteToJob = () => this.setState({ show_invite_project: false })
  onCloseModal = () => this.setState({ currentModalContent: null, modalProps: {} })
  hideShareModal = () => this.setState({ showShareModal: false })
  enableLoad = () => this.setState({ show_loading: true })
  disableLoad = () => this.setState({ show_loading: false })
  setLoading = (show_loading, loading_msg = null, showSpinner = true) => {
    if (this.state.show_loading === show_loading && this.state.loading_msg === loading_msg) return null
    this.setState(() => ({ loading_msg: show_loading ? loading_msg : null, showSpinner, show_loading }))
  }
  onCloseAddBoard = () => this.setState({ show_add_board_modal: false })
  onCloseInviteFriend = () => this.setState({ show_invite_friend: false })
  hideInviteToJobPopup = () => this.setState({ show_invite_project: false })
  inviteAFriend = () => this.setState({ show_invite_friend: true })
  onOpenModal = (modal, modalProps = {}) => this.setState({ currentModalContent: modal, modalProps })

  render() {
    // TODO move to root context
    const rootProps = {
      toggleMiniChat: this.toggleMiniChat,
      pressSidebarChat: this.pressSidebarChat,
      inviteAFriend: this.inviteAFriend,
      toggleShareModal: this.toggleShareModal,
      hideShareModal: this.hideShareModal,
      toggleInviteToJobPopup: this.toggleInviteToJobPopup,
      hideInviteToJobPopup: this.hideInviteToJobPopup,
      toggleConnectRequestRecipient: this.toggleConnectRequestRecipient,
      toggleConnectRequestSender: this.toggleConnectRequestSender,
      hideConnectRequestRecipient: this.hideConnectRequestRecipient,
      toggleAddBoardModal: this.toggleAddBoardModal,
      enableLoad: this.enableLoad,
      disableLoad: this.disableLoad,
    }

    const isMobileFooterEnabled =
      ApplicationHelper.isMobile && AuthHelper.logged_in && this.state.mode !== searchParams.modes.guestOnboarding

    const modalContextProps = {
      toggleAddBoardModal: this.toggleAddBoardModal,
      onCloseConnectRequest: this.onCloseConnectRequest,
      onCloseConnectRequestSender: this.onCloseConnectRequestSender,
      onCloseShare: this.onCloseShare,
      onCloseInviteToJob: this.onCloseInviteToJob,
      onCloseAddBoard: this.onCloseAddBoard,
      onCloseInviteFriend: this.onCloseInviteFriend,
      onCloseModal: this.onCloseModal,
      onOpenModal: this.onOpenModal,
      onChangeManualOverflow: this.onChangeManualOverflow,
      ...this.state,
    }

    const rootContextProps = {
      setOnAuthSuccess: this.setOnAuthSuccess,
      onAuthSuccess: this.handleAuthSuccess,
      toggleConnectRequestRecipient: this.toggleConnectRequestRecipient, // currently disabled
      toggleConnectRequestSender: this.toggleConnectRequestSender, // currently disabled
      mode: this.state.mode,
      toggleInviteToJobPopup: this.toggleInviteToJobPopup,
      setMode: this.setMode,
      setLoading: this.setLoading,
      isLoading: this.state.show_loading,
      isMobileFooterEnabled,
    }

    return (
      <ModalContext.Provider value={modalContextProps}>
        <BrowserRouter>
          <RootContext.Provider value={rootContextProps}>
            <Modal
              manualOverflow={this.state.manualOverflow}
              content={this.state.currentModalContent}
              onClose={this.onCloseModal}
              modalProps={this.state.modalProps}
            >
              {this.embedMode() ? null : <Header rootProps={rootProps} />}

              <Wrapper className="root_wrapper">
                {this.props.showUaBaner ? <UaBanner /> : null}
                {this.faviconHighlighter() ? <FaviconHighlighter /> : null}

                <Suspense fallback={<LoadingComponent />}>
                  <Router
                    rootProps={rootProps}
                    // state={this.state}
                    // hideChatWindow={this.hideChatWindow}
                    // toggleMessenger={this.toggleMessenger}
                  />
                </Suspense>

                {isMobileFooterEnabled && <MobileNavigation />}
                <Footer />
                <ModalsView rootProps={rootProps} />
              </Wrapper>
            </Modal>

            <LoadingScreen
              loading={this.state.show_loading && this.state.showSpinner}
              loading_msg={this.state.loading_msg}
            />
          </RootContext.Provider>
        </BrowserRouter>
      </ModalContext.Provider>
    )
  }
}

export default withRouter(withUaBannerProvider(connect()(RootWrapper)))
